const ClassesImg = './markers/classes.svg'
const ClassesPinImg = './markers/classes_default.svg'
const ClassesPinSelectedImg = './markers/classes_selected.svg'

export class CityPin extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
        <img alt="Город" class="pin-img">
        <span class="city-badge"></span>
    `

    this.pinImg = this.querySelector('img.pin-img')
    this.text = this.querySelector('span.city-badge')
    this.mounted = true
    this.render()
  }

  render() {
    if (!this.mounted) {
      return
    }

    const active = this.hasAttribute('active')
    const alwaysShow = this.hasAttribute('always-show')
    const image = !!active ? ClassesPinImg : ClassesPinSelectedImg
    const x = parseInt(this.getAttribute('posx')),
      y = parseInt(this.getAttribute('posy'))

    this.pinImg.setAttribute('src', image)
    this.text.innerText = this.getAttribute('name')

    this.style.top = (y - this.pinImg.height * 0.75) + 'px'
    this.style.left = (x - this.pinImg.width / 2) + 'px'

    if (active)
      this.pinImg.classList.add('pin-img-hovered')
    else
      this.pinImg.classList.remove('pin-img-hovered')

    if (alwaysShow || active)
      this.text.style.opacity = '1'
    else
      this.text.style.opacity = '0'

    if (alwaysShow)
      this.text.classList.add('always-show')
  }

  static get observedAttributes() {
    return ['active', 'name', 'posx', 'posy', 'always-show'];
  }

  attributeChangedCallback() {
    this.render();
  }
}

